import * as Headless from '@sail/theme-headless';
import {css, theme} from '../theme';

/**
 * '& > svg' overrides should be replaced with adaptive defaults once those
 * APIs support per-prop defaults
 */

export const Link = theme(Headless.Link, [
  css({
    borderRadius: 'xsmall',
    fontWeight: 'semibold',
    height: css.value('fit-content'),
    width: css.value('fit-content'),
    gap: 'small',
    alignY: 'center',
    [Headless.LinkVariants.type.primary]: {
      color: 'brand',
      '&:hover': {
        color: css.value('$color.brand600'),
      },
      '& > svg': {
        color: css.value('$iconColor.brand'),
      },
    },
    [Headless.LinkVariants.type.secondary]: {
      color: 'primary',
      textDecoration: css.value('underline'),
      textDecorationStyle: css.value('dashed'),
      textDecorationColor: css.value('$color.neutral300'),
      textUnderlineOffset: css.value('1.5px'),
      '&:hover': {
        textDecorationColor: css.value('$color.brand500'),
        textDecorationStyle: css.value('solid'),
      },
      '& > svg': {
        color: css.value('$iconColor.primary'),
      },
    },
    [Headless.ActionVariants.disabled.true]: {
      color: 'disabled',
      pointerEvents: css.value('none'),
      '& > svg': {
        color: 'disabled',
      },
    },
  }),
]);
